import { styled } from "styled-components";

export const FABWrapper = styled.div<{ $hasCoordinates?: boolean }>`
  position: fixed;
  bottom: ${(props) => (props.$hasCoordinates ? "85px" : "10px")};
  right: calc((100% - 960px) / 2);
  padding: 12px;
  width: 56px;
  height: 56px;
  background: #d4dffd;
  border-radius: 50%;
  border: none;
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.2),
    0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;

  /* Desktop */
  @media (min-width: 1021px) {
    right: calc((100% - 960px) / 2);
  }

  /* Tablet */
  @media (max-width: 1020px) and (min-width: 768px) {
    right: 20px;
    left: ${(props) => (props.$hasCoordinates ? "87%" : "auto")};
    transform: none;
  }

  @media (max-width: 767px) {
    right: 10px;
    left: ${(props) => (props.$hasCoordinates ? "85%" : "auto")};
    transform: none;
  }

  @media (max-width: 479px) {
    right: 10px;
    left: ${(props) => (props.$hasCoordinates ? "75%" : "auto")};
    transform: none;
  }

  @media (max-width: 415px) {
    right: 10px;
    left: ${(props) => (props.$hasCoordinates ? "70%" : "auto")};
    transform: none;
  }
  @media (max-width: 375px) {
    right: 10px;
    left: ${(props) => (props.$hasCoordinates ? "70%" : "auto")};
    transform: none;
  }

  &:hover {
    @media (min-width: 1021px) {
      transform: translateY(-2px);
    }
    @media (max-width: 1020px) {
      transform: translateY(-2px);
    }
  }
`;

export const FABImage = styled.img`
  width: 56px;
  height: 56px;
  object-fit: contain;
  background: white;
  border-radius: 99px;
`;

export const RotateOnHover = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: rotate(45deg);
  }
`;
